import {AlertService} from '../../shared/services/alert.service';
import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router,ActivatedRoute } from "@angular/router";

import { Assessment } from "../../shared/models/assessment";
import { SaveMessages } from "../../shared/models/save-messages";
import { AssessmentService } from "../../shared/services/assessment.service";
import { Scale } from "../../shared/models/scale";
import { QuestionSet } from "../../shared/models/question-set";
import { AssessmentHydrator } from '../../shared/services/assessment-hydrator.service';
import { AssessmentCompressorService } from 'app/shared/services/assessment-compressor.service';

@Component({
  selector: 'app-assessment-edit',
  templateUrl: './assessment-edit.component.html',
  styleUrls: ['./assessment-edit.component.css']
})
export class AssessmentEditComponent implements OnInit {

	private _assessment:Assessment;
	public hasLoadedAssessment:boolean;
	private _messages:SaveMessages;
	@ViewChild('reportContents') reportContents:ElementRef;

  constructor(
    private _assessmentService:AssessmentService
		,private assessmentCompressor:AssessmentCompressorService
		,private router: Router
		,private alertService:AlertService
		,private hydrator:AssessmentHydrator
    ,private route: ActivatedRoute
  ) {
		this.hasLoadedAssessment = false;
    this._messages = new SaveMessages();
    this._assessment = new Assessment();
  }

  ngOnInit() {
	let uid = this.route.snapshot.params['uid'];
	let version = this.route.snapshot.queryParams['version'];
	

	this._assessmentService.uid = uid;
	let assessmentPromise;
    if (version) {
      assessmentPromise = this._assessmentService.getAssessmentVersion(uid, version);
    } else {
      assessmentPromise = this._assessmentService.getAssessment(uid);
    }
    assessmentPromise.then((assessment) => {
				if (assessment) {
					// if we have nothing back in the admin then we are going to create our own
					this.assessment = assessment;
					this.hasLoadedAssessment = true;
				}
				else {
					// TODO: stephen handle 404 errors
					//this._$state.go("404");
          this.router.navigate(["page-not-found"]);
				}
			}, (error) => {
				this.hasLoadedAssessment = true;
				// TODO: stephen can't all of this just go in the catch block below?
				console.error(error);
				this.alertService.error("Failed to retrieve assessment data from server");
				this.assessment = new Assessment();
				this.assessment.uid = this._assessmentService.uid;
			})
			.catch(function(error) {
				this.hasLoadedAssessment = true;
				this.alertService.error("Failed to retrieve assessment data from server");
				console.error(error);
			})
  }

  get assessment() {
    return this._assessment;
  }
  set assessment(v:Assessment) {
    this._assessment = v;
  }

  get messages() {
    return this._messages;
  }

  getRawAssessment() {
	  return JSON.stringify(this.assessmentCompressor.compress(this.assessment), null, " ");
  }

  save() {
		console.log(this._assessment);
		this._assessmentService.saveAssessment(this._assessment)
		.then(() => {
			this.alertService.success("Assessment Saved!");
		}).catch(() => {
				this.alertService.error("Error occurred in saving your assessment. Please try again.");
		});
	}

	public updateAssessmentContents() {
    let reportContents = this.reportContents.nativeElement as HTMLTextAreaElement;
    let jsonData = reportContents.value;
    let assessmentJSON;
    try {
			assessmentJSON = JSON.parse(jsonData);
			this.assessment = this.hydrator.hydrate(assessmentJSON);
      this.alertService.info("Assessment contents updated.  Make sure to save the assessment before proceeding");
    }
    catch (error) {
      this.alertService.error("The assessment contains invalid JSON and could not be parsed");
      console.error(error);
    }
    
  }

	moveUpScale(scale:Scale) {
		this.assessment.shiftScaleUp(scale);
	}
	moveDownScale(scale:Scale) {
		this.assessment.shiftScaleDown(scale);
	}

  moveUpSet(questionSet:QuestionSet) {
		this.assessment.shiftQuestionSetUp(questionSet);
		this.save();
	}
	
	moveDownSet(questionSet:QuestionSet) {
		this.assessment.shiftQuestionSetDown(questionSet);
		this.save();
	}
	
	deleteQuestionSet(questionSet:QuestionSet) {
		if (!confirm("Are you sure you want to delete this question set?")) {
			return; 
		}
		this.assessment.removeQuestionSet(questionSet);
		this._assessmentService.saveAssessment(this.assessment).then(() => {

		})
		.catch((error) => {
			console.error(error);
			this.alertService.error("An error occurred in removing the question set.");
		})
	}
	deleteScale(scale:Scale) {
		if (!confirm("Are you sure you want to delete this scale?")) {
			return; 
		}
		scale.isDeleted = true;
		this.assessment.removeScale(scale);
		this._assessmentService.saveAssessment(this.assessment).then(() => {
			this.alertService.success("Scale deleted...");
			// we don't do anything here...
		}, () => {
			// TODO: stephen handle the error
			this.alertService.error("Error occurred.  Could not delete this scale");
			scale.isDeleted = false;
			this.assessment.addScale(scale);
		})
	}

}



// WEBPACK FOOTER //
// ./src/app/admin/assessment-edit/assessment-edit.component.ts